import { Box, Divider } from '@mui/material'
import { ClimatePanel } from './climate/climate-panel'
import { OrgMetricsPanel } from './org-metrics/org-metrics-panel'

export const MetricsContent = () => (
  <Box sx={{ height: '100%', display: 'flex', flexDirection: 'row', overflow: 'hidden' }}>
    {/* Left: climate / GDD — ~1/3 */}
    <Box sx={{ flex: '1 1 0', minWidth: 0 }}>
      <ClimatePanel />
    </Box>

    <Divider orientation="vertical" flexItem sx={{ borderRightWidth: '4px' }} />

    {/* Right: org-specific metrics — ~2/3 */}
    <Box sx={{ flex: '2 1 0', minWidth: 0 }}>
      <OrgMetricsPanel />
    </Box>
  </Box>
)
